import { useState, type FormEvent } from "react";
import { createFileRoute, Link } from "@tanstack/react-router";
import { api } from "../../lib/api.js";
import { AuthCardShell } from "../../components/auth-card-shell.js";

export const Route = createFileRoute("/_public/forgot-password")({
  component: ForgotPasswordPage,
});

function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/auth/request-password-reset", { email });
    } catch {
      // Silent — endpoint always returns 200 anyway.
    } finally {
      setSubmitted(true);
      setSubmitting(false);
    }
  }

  if (submitted) {
    return (
      <AuthCardShell>
        <div className="brut-card">
          <h1 style={{ fontSize: 28, fontWeight: 900, margin: "0 0 12px" }}>
            Check your email
          </h1>
          <p>
            If <strong>{email}</strong> matches an account, we just sent a
            password reset link. It expires in 1 hour.
          </p>
          <p style={{ marginTop: 24, fontSize: 14 }}>
            <Link to="/login">Back to sign in</Link>
          </p>
        </div>
      </AuthCardShell>
    );
  }

  return (
    <AuthCardShell>
      <div className="brut-card">
        <h1 style={{ fontSize: 32, fontWeight: 900, margin: "0 0 12px" }}>
          Reset password
        </h1>
        <p style={{ color: "var(--muted)" }}>
          Enter your email; we'll send a link to set a new password.
        </p>
        <form onSubmit={handleSubmit}>
          <div style={{ marginTop: 16 }}>
            <label className="brut-label" htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              className="brut-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            className="brut-button"
            disabled={submitting}
            style={{ marginTop: 24, width: "100%" }}
          >
            {submitting ? "Sending…" : "Send reset link"}
          </button>
        </form>
        <p style={{ marginTop: 24, fontSize: 14 }}>
          <Link to="/login">Back to sign in</Link>
        </p>
      </div>
    </AuthCardShell>
  );
}
